/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.productos': 'Productos',
  'sidebar.adminproductos': 'Productos',
  'productos.agregarProductos': 'Crear productos',
  'productos.modificarProductos': 'Editar productos',
  'productos.productoId': 'Producto Id',
  'productos.empresaId': 'Empresa Id',
  'productos.estado': 'Estado',
  'productos.VerProductos': 'Ver Productos',
  'productos.descripcionProducto': 'Descripción',
};
